export const border_box = `
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
`;

export const container = `
  .container {
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
    margin-right: auto;
    margin-left: auto;
  }

  @media (min-width: 576px) {
    .container {
      max-width: 540px;
    }
  }

  @media (min-width: 768px) {
    .container {
      max-width: 720px;
    }
  }

  @media (min-width: 992px) {
    .container {
      max-width: 960px;
    }
  }

  @media (min-width: 1320px) {
    .container {
      max-width: 1260px;
    }
  }
`;

export const container_fluid = `
  .container-fluid {
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
    margin-right: auto;
    margin-left: auto;
  }
`;

export const row = `
  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -12px;
    margin-left: -12px;
  }
`;

export const no_gutters = `
  .no-gutters {
    margin-right: 0;
    margin-left: 0;
  }

  .no-gutters>.col, .no-gutters>[class*="col-"] {
    padding-right: 0;
    padding-left: 0;
  }
`;

export const col_1 = `
  .col-1 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }
`;

export const col_2 = `
  .col-2 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }
`;

export const col_3 = `
  .col-3 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
    flex: 0 0 25%;
    max-width: 25%;
  }
`;

export const col_4 = `
  .col-4 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }
`;

export const col_5 = `
  .col-5 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }
`;

export const col_6 = `
  .col-6 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
    flex: 0 0 50%;
    max-width: 50%;
  }
`;

export const col_7 = `
  .col-7 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }
`;

export const col_8 = `
  .col-8 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }
`;

export const col_9 = `
  .col-9 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
    flex: 0 0 75%;
    max-width: 75%;
  }
`;

export const col_10 = `
  .col-10 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }
`;

export const col_11 = `
  .col-11 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }
`;

export const col_12 = `
  .col-12 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
    flex: 0 0 100%;
    max-width: 100%;
  }
`;

export const col = `
  .col {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
`;

export const col_auto = `
  .col-auto {
    position: relative;
    padding-right: 12px;
    padding-left: 12px;
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
`;

export const col_sm_1 = `
  .col-sm-1 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 576px) {
    .col-sm-1 {
      flex: 0 0 8.33333%;
      max-width: 8.33333%;
    }
  }
`;

export const col_sm_2 = `
  .col-sm-2 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 576px) {
    .col-sm-2 {
      flex: 0 0 16.66667%;
      max-width: 16.66667%;
    }
  }
`;

export const col_sm_3 = `
  .col-sm-3 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 576px) {
    .col-sm-3 {
      flex: 0 0 25%;
      max-width: 25%;
    }
  }
`;

export const col_sm_4 = `
  .col-sm-4 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 576px) {
    .col-sm-4 {
      flex: 0 0 33.33333%;
      max-width: 33.33333%;
    }
  }
`;

export const col_sm_5 = `
  .col-sm-5 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 576px) {
    .col-sm-5 {
      flex: 0 0 41.66667%;
      max-width: 41.66667%;
    }
  }
`;

export const col_sm_6 = `
  .col-sm-6 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 576px) {
    .col-sm-6 {
      flex: 0 0 50%;
      max-width: 50%;
    }
  }
`;

export const col_sm_7 = `
  .col-sm-7 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 576px) {
    .col-sm-7 {
      flex: 0 0 58.33333%;
      max-width: 58.33333%;
    }
  }
`;

export const col_sm_8 = `
  .col-sm-8 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 576px) {
    .col-sm-8 {
      flex: 0 0 66.66667%;
      max-width: 66.66667%;
    }
  }
`;

export const col_sm_9 = `
  .col-sm-9 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 576px) {
    .col-sm-9 {
      flex: 0 0 75%;
      max-width: 75%;
    }
  }
`;

export const col_sm_10 = `
  .col-sm-10 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 576px) {
    .col-sm-10 {
      flex: 0 0 83.33333%;
      max-width: 83.33333%;
    }
  }
`;

export const col_sm_11 = `
  .col-sm-11 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 576px) {
    .col-sm-11 {
      flex: 0 0 91.66667%;
      max-width: 91.66667%;
    }
  }
`;

export const col_sm_12 = `
  .col-sm-12 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 576px) {
    .col-sm-12 {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;

export const col_sm = `
  .col-sm {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 576px) {
    .col-sm {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
    }
  }
`;

export const col_sm_auto = `
  .col-sm-auto {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 576px) {
    .col-sm-auto {
      flex: 0 0 auto;
      width: auto;
      max-width: 100%;
    }
  }
`;

export const col_md_1 = `
  .col-md-1 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 768px) {
    .col-md-1 {
      flex: 0 0 8.33333%;
      max-width: 8.33333%;
    }
  }
`;

export const col_md_2 = `
  .col-md-2 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 768px) {
    .col-md-2 {
      flex: 0 0 16.66667%;
      max-width: 16.66667%;
    }
  }
`;

export const col_md_3 = `
  .col-md-3 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 768px) {
    .col-md-3 {
      flex: 0 0 25%;
      max-width: 25%;
    }
  }
`;

export const col_md_4 = `
  .col-md-4 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 768px) {
    .col-md-4 {
      flex: 0 0 33.33333%;
      max-width: 33.33333%;
    }
  }
`;

export const col_md_5 = `
  .col-md-5 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 768px) {
    .col-md-5 {
      flex: 0 0 41.66667%;
      max-width: 41.66667%;
    }
  }
`;

export const col_md_6 = `
  .col-md-6 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 768px) {
    .col-md-6 {
      flex: 0 0 50%;
      max-width: 50%;
    }
  }
`;

export const col_md_7 = `
  .col-md-7 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 768px) {
    .col-md-7 {
      flex: 0 0 58.33333%;
      max-width: 58.33333%;
    }
  }
`;

export const col_md_8 = `
  .col-md-8 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 768px) {
    .col-md-8 {
      flex: 0 0 66.66667%;
      max-width: 66.66667%;
    }
  }
`;

export const col_md_9 = `
  .col-md-9 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 768px) {
    .col-md-9 {
      flex: 0 0 75%;
      max-width: 75%;
    }
  }
`;

export const col_md_10 = `
  .col-md-10 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 768px) {
    .col-md-10 {
      flex: 0 0 83.33333%;
      max-width: 83.33333%;
    }
  }
`;

export const col_md_11 = `
  .col-md-11 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 768px) {
    .col-md-11 {
      flex: 0 0 91.66667%;
      max-width: 91.66667%;
    }
  }
`;

export const col_md_12 = `
  .col-md-12 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 768px) {
    .col-md-12 {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;

export const col_md = `
  .col-md {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 768px) {
    .col-md {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
    }
  }
`;

export const col_md_auto = `
  .col-md-auto {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 768px) {
    .col-md-auto {
      flex: 0 0 auto;
      width: auto;
      max-width: 100%;
    }
  }
`;

export const col_lg_1 = `
  .col-lg-1 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 992px) {
    .col-lg-1 {
      flex: 0 0 8.33333%;
      max-width: 8.33333%;
    }
  }
`;

export const col_lg_2 = `
  .col-lg-2 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 992px) {
    .col-lg-2 {
      flex: 0 0 16.66667%;
      max-width: 16.66667%;
    }
  }
`;

export const col_lg_3 = `
  .col-lg-3 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 992px) {
    .col-lg-3 {
      flex: 0 0 25%;
      max-width: 25%;
    }
  }
`;

export const col_lg_4 = `
  .col-lg-4 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 992px) {
    .col-lg-4 {
      flex: 0 0 33.33333%;
      max-width: 33.33333%;
    }
  }
`;

export const col_lg_5 = `
  .col-lg-5 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 992px) {
    .col-lg-5 {
      flex: 0 0 41.66667%;
      max-width: 41.66667%;
    }
  }
`;

export const col_lg_6 = `
  .col-lg-6 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 992px) {
    .col-lg-6 {
      flex: 0 0 50%;
      max-width: 50%;
    }
  }
`;

export const col_lg_7 = `
  .col-lg-7 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 992px) {
    .col-lg-7 {
      flex: 0 0 58.33333%;
      max-width: 58.33333%;
    }
  }
`;

export const col_lg_8 = `
  .col-lg-8 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 992px) {
    .col-lg-8 {
      flex: 0 0 66.66667%;
      max-width: 66.66667%;
    }
  }
`;

export const col_lg_9 = `
  .col-lg-9 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 992px) {
    .col-lg-9 {
      flex: 0 0 75%;
      max-width: 75%;
    }
  }
`;

export const col_lg_10 = `
  .col-lg-10 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 992px) {
    .col-lg-10 {
      flex: 0 0 83.33333%;
      max-width: 83.33333%;
    }
  }
`;

export const col_lg_11 = `
  .col-lg-11 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 992px) {
    .col-lg-11 {
      flex: 0 0 91.66667%;
      max-width: 91.66667%;
    }
  }
`;

export const col_lg_12 = `
  .col-lg-12 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 992px) {
    .col-lg-12 {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;

export const col_lg = `
  .col-lg {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 992px) {
    .col-lg {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
    }
  }
`;

export const col_lg_auto = `
  .col-lg-auto {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 992px) {
    .col-lg-auto {
      flex: 0 0 auto;
      width: auto;
      max-width: 100%;
    }
  }
`;

export const col_xl_1 = `
  .col-xl-1 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 1320px) {
    .col-xl-1 {
      flex: 0 0 8.33333%;
      max-width: 8.33333%;
    }
  }
`;

export const col_xl_2 = `
  .col-xl-2 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 1320px) {
    .col-xl-2 {
      flex: 0 0 16.66667%;
      max-width: 16.66667%;
    }
  }
`;

export const col_xl_3 = `
  .col-xl-3 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 1320px) {
    .col-xl-3 {
      flex: 0 0 25%;
      max-width: 25%;
    }
  }
`;

export const col_xl_4 = `
  .col-xl-4 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 1320px) {
    .col-xl-4 {
      flex: 0 0 33.33333%;
      max-width: 33.33333%;
    }
  }
`;

export const col_xl_5 = `
  .col-xl-5 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 1320px) {
    .col-xl-5 {
      flex: 0 0 41.66667%;
      max-width: 41.66667%;
    }
  }
`;

export const col_xl_6 = `
  .col-xl-6 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 1320px) {
    .col-xl-6 {
      flex: 0 0 50%;
      max-width: 50%;
    }
  }
`;

export const col_xl_7 = `
  .col-xl-7 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 1320px) {
    .col-xl-7 {
      flex: 0 0 58.33333%;
      max-width: 58.33333%;
    }
  }
`;

export const col_xl_8 = `
  .col-xl-8 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 1320px) {
    .col-xl-8 {
      flex: 0 0 66.66667%;
      max-width: 66.66667%;
    }
  }
`;

export const col_xl_9 = `
  .col-xl-9 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 1320px) {
    .col-xl-9 {
      flex: 0 0 75%;
      max-width: 75%;
    }
  }
`;

export const col_xl_10 = `
  .col-xl-10 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 1320px) {
    .col-xl-10 {
      flex: 0 0 83.33333%;
      max-width: 83.33333%;
    }
  }
`;

export const col_xl_11 = `
  .col-xl-11 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 1320px) {
    .col-xl-11 {
      flex: 0 0 91.66667%;
      max-width: 91.66667%;
    }
  }
`;

export const col_xl_12 = `
  .col-xl-12 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 1320px) {
    .col-xl-12 {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;

export const col_xl = `
  .col-xl {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 1320px) {
    .col-xl {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
    }
  }
`;

export const col_xl_auto = `
  .col-xl-auto {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }

  @media (min-width: 1320px) {
    .col-xl-auto {
      flex: 0 0 auto;
      width: auto;
      max-width: 100%;
    }
  }
`;

export const order_first = `
  .order-first {
    order: -1;
  }
`;

export const order_last = `
  .order-last {
    order: 13;
  }
`;

export const order_0 = `
  .order-0 {
    order: 0;
  }
`;

export const order_1 = `
  .order-1 {
    order: 1;
  }
`;

export const order_2 = `
  .order-2 {
    order: 2;
  }
`;

export const order_3 = `
  .order-3 {
    order: 3;
  }
`;

export const order_4 = `
  .order-4 {
    order: 4;
  }
`;

export const order_5 = `
  .order-5 {
    order: 5;
  }
`;

export const order_6 = `
  .order-6 {
    order: 6;
  }
`;

export const order_7 = `
  .order-7 {
    order: 7;
  }
`;

export const order_8 = `
  .order-8 {
    order: 8;
  }
`;

export const order_9 = `
  .order-9 {
    order: 9;
  }
`;

export const order_10 = `
  .order-10 {
    order: 10;
  }
`;

export const order_11 = `
  .order-11 {
    order: 11;
  }
`;

export const order_12 = `
  .order-12 {
    order: 12;
  }
`;

export const offset_1 = `
  .offset-1 {
    margin-left: 8.33333%;
  }
`;

export const offset_2 = `
  .offset-2 {
    margin-left: 16.66667%;
  }
`;

export const offset_3 = `
  .offset-3 {
    margin-left: 25%;
  }
`;

export const offset_4 = `
  .offset-4 {
    margin-left: 33.33333%;
  }
`;

export const offset_5 = `
  .offset-5 {
    margin-left: 41.66667%;
  }
`;

export const offset_6 = `
  .offset-6 {
    margin-left: 50%;
  }
`;

export const offset_7 = `
  .offset-7 {
    margin-left: 58.33333%;
  }
`;

export const offset_8 = `
  .offset-8 {
    margin-left: 66.66667%;
  }
`;

export const offset_9 = `
  .offset-9 {
    margin-left: 75%;
  }
`;

export const offset_10 = `
  .offset-10 {
    margin-left: 83.33333%;
  }
`;

export const offset_11 = `
  .offset-11 {
    margin-left: 91.66667%;
  }
`;

export const order_sm_first = `
  @media (min-width: 576px) {
    .order-sm-first {
      order: -1;
    }
  }
`;

export const order_sm_last = `
  @media (min-width: 576px) {
    .order-sm-last {
      order: 13;
    }
  }
`;

export const order_sm_0 = `
  @media (min-width: 576px) {
    .order-sm-0 {
      order: 0;
    }
  }
`;

export const order_sm_1 = `
  @media (min-width: 576px) {
    .order-sm-1 {
      order: 1;
    }
  }
`;

export const order_sm_2 = `
  @media (min-width: 576px) {
    .order-sm-2 {
      order: 2;
    }
  }
`;

export const order_sm_3 = `
  @media (min-width: 576px) {
    .order-sm-3 {
      order: 3;
    }
  }
`;

export const order_sm_4 = `
  @media (min-width: 576px) {
    .order-sm-4 {
      order: 4;
    }
  }
`;

export const order_sm_5 = `
  @media (min-width: 576px) {
    .order-sm-5 {
      order: 5;
    }
  }
`;

export const order_sm_6 = `
  @media (min-width: 576px) {
    .order-sm-6 {
      order: 6;
    }
  }
`;

export const order_sm_7 = `
  @media (min-width: 576px) {
    .order-sm-7 {
      order: 7;
    }
  }
`;

export const order_sm_8 = `
  @media (min-width: 576px) {
    .order-sm-8 {
      order: 8;
    }
  }
`;

export const order_sm_9 = `
  @media (min-width: 576px) {
    .order-sm-9 {
      order: 9;
    }
  }
`;

export const order_sm_10 = `
  @media (min-width: 576px) {
    .order-sm-10 {
      order: 10;
    }
  }
`;

export const order_sm_11 = `
  @media (min-width: 576px) {
    .order-sm-11 {
      order: 11;
    }
  }
`;

export const order_sm_12 = `
  @media (min-width: 576px) {
    .order-sm-12 {
      order: 12;
    }
  }
`;

export const offset_sm_0 = `
  @media (min-width: 576px) {
    .offset-sm-0 {
      margin-left: 0;
    }
  }
`;

export const offset_sm_1 = `
  @media (min-width: 576px) {
    .offset-sm-1 {
      margin-left: 8.33333%;
    }
  }
`;

export const offset_sm_2 = `
  @media (min-width: 576px) {
    .offset-sm-2 {
      margin-left: 16.66667%;
    }
  }
`;

export const offset_sm_3 = `
  @media (min-width: 576px) {
    .offset-sm-3 {
      margin-left: 25%;
    }
  }
`;

export const offset_sm_4 = `
  @media (min-width: 576px) {
    .offset-sm-4 {
      margin-left: 33.33333%;
    }
  }
`;

export const offset_sm_5 = `
  @media (min-width: 576px) {
    .offset-sm-5 {
      margin-left: 41.66667%;
    }
  }
`;

export const offset_sm_6 = `
  @media (min-width: 576px) {
    .offset-sm-6 {
      margin-left: 50%;
    }
  }
`;

export const offset_sm_7 = `
  @media (min-width: 576px) {
    .offset-sm-7 {
      margin-left: 58.33333%;
    }
  }
`;

export const offset_sm_8 = `
  @media (min-width: 576px) {
    .offset-sm-8 {
      margin-left: 66.66667%;
    }
  }
`;

export const offset_sm_9 = `
  @media (min-width: 576px) {
    .offset-sm-9 {
      margin-left: 75%;
    }
  }
`;

export const offset_sm_10 = `
  @media (min-width: 576px) {
    .offset-sm-10 {
      margin-left: 83.33333%;
    }
  }
`;

export const offset_sm_11 = `
  @media (min-width: 576px) {
    .offset-sm-11 {
      margin-left: 91.66667%;
    }
  }
`;

export const order_md_first = `
  @media (min-width: 768px) {
    .order-md-first {
      order: -1;
    }
  }
`;

export const order_md_last = `
  @media (min-width: 768px) {
    .order-md-last {
      order: 13;
    }
  }
`;

export const order_md_0 = `
  @media (min-width: 768px) {
    .order-md-0 {
      order: 0;
    }
  }
`;

export const order_md_1 = `
  @media (min-width: 768px) {
    .order-md-1 {
      order: 1;
    }
  }
`;

export const order_md_2 = `
  @media (min-width: 768px) {
    .order-md-2 {
      order: 2;
    }
  }
`;

export const order_md_3 = `
  @media (min-width: 768px) {
    .order-md-3 {
      order: 3;
    }
  }
`;

export const order_md_4 = `
  @media (min-width: 768px) {
    .order-md-4 {
      order: 4;
    }
  }
`;

export const order_md_5 = `
  @media (min-width: 768px) {
    .order-md-5 {
      order: 5;
    }
  }
`;

export const order_md_6 = `
  @media (min-width: 768px) {
    .order-md-6 {
      order: 6;
    }
  }
`;

export const order_md_7 = `
  @media (min-width: 768px) {
    .order-md-7 {
      order: 7;
    }
  }
`;

export const order_md_8 = `
  @media (min-width: 768px) {
    .order-md-8 {
      order: 8;
    }
  }
`;

export const order_md_9 = `
  @media (min-width: 768px) {
    .order-md-9 {
      order: 9;
    }
  }
`;

export const order_md_10 = `
  @media (min-width: 768px) {
    .order-md-10 {
      order: 10;
    }
  }
`;

export const order_md_11 = `
  @media (min-width: 768px) {
    .order-md-11 {
      order: 11;
    }
  }
`;

export const order_md_12 = `
  @media (min-width: 768px) {
    .order-md-12 {
      order: 12;
    }
  }
`;

export const offset_md_0 = `
  @media (min-width: 768px) {
    .offset-md-0 {
      margin-left: 0;
    }
  }
`;

export const offset_md_1 = `
  @media (min-width: 768px) {
    .offset-md-1 {
      margin-left: 8.33333%;
    }
  }
`;

export const offset_md_2 = `
  @media (min-width: 768px) {
    .offset-md-2 {
      margin-left: 16.66667%;
    }
  }
`;

export const offset_md_3 = `
  @media (min-width: 768px) {
    .offset-md-3 {
      margin-left: 25%;
    }
  }
`;

export const offset_md_4 = `
  @media (min-width: 768px) {
    .offset-md-4 {
      margin-left: 33.33333%;
    }
  }
`;

export const offset_md_5 = `
  @media (min-width: 768px) {
    .offset-md-5 {
      margin-left: 41.66667%;
    }
  }
`;

export const offset_md_6 = `
  @media (min-width: 768px) {
    .offset-md-6 {
      margin-left: 50%;
    }
  }
`;

export const offset_md_7 = `
  @media (min-width: 768px) {
    .offset-md-7 {
      margin-left: 58.33333%;
    }
  }
`;

export const offset_md_8 = `
  @media (min-width: 768px) {
    .offset-md-8 {
      margin-left: 66.66667%;
    }
  }
`;

export const offset_md_9 = `
  @media (min-width: 768px) {
    .offset-md-9 {
      margin-left: 75%;
    }
  }
`;

export const offset_md_10 = `
  @media (min-width: 768px) {
    .offset-md-10 {
      margin-left: 83.33333%;
    }
  }
`;

export const offset_md_11 = `
  @media (min-width: 768px) {
    .offset-md-11 {
      margin-left: 91.66667%;
    }
  }
`;

export const order_lg_first = `
  @media (min-width: 992px) {
    .order-lg-first {
      order: -1;
    }
  }
`;

export const order_lg_last = `
  @media (min-width: 992px) {
    .order-lg-last {
      order: 13;
    }
  }
`;

export const order_lg_0 = `
  @media (min-width: 992px) {
    .order-lg-0 {
      order: 0;
    }
  }
`;

export const order_lg_1 = `
  @media (min-width: 992px) {
    .order-lg-1 {
      order: 1;
    }
  }
`;

export const order_lg_2 = `
  @media (min-width: 992px) {
    .order-lg-2 {
      order: 2;
    }
  }
`;

export const order_lg_3 = `
  @media (min-width: 992px) {
    .order-lg-3 {
      order: 3;
    }
  }
`;

export const order_lg_4 = `
  @media (min-width: 992px) {
    .order-lg-4 {
      order: 4;
    }
  }
`;

export const order_lg_5 = `
  @media (min-width: 992px) {
    .order-lg-5 {
      order: 5;
    }
  }
`;

export const order_lg_6 = `
  @media (min-width: 992px) {
    .order-lg-6 {
      order: 6;
    }
  }
`;

export const order_lg_7 = `
  @media (min-width: 992px) {
    .order-lg-7 {
      order: 7;
    }
  }
`;

export const order_lg_8 = `
  @media (min-width: 992px) {
    .order-lg-8 {
      order: 8;
    }
  }
`;

export const order_lg_9 = `
  @media (min-width: 992px) {
    .order-lg-9 {
      order: 9;
    }
  }
`;

export const order_lg_10 = `
  @media (min-width: 992px) {
    .order-lg-10 {
      order: 10;
    }
  }
`;

export const order_lg_11 = `
  @media (min-width: 992px) {
    .order-lg-11 {
      order: 11;
    }
  }
`;

export const order_lg_12 = `
  @media (min-width: 992px) {
    .order-lg-12 {
      order: 12;
    }
  }
`;

export const offset_lg_0 = `
  @media (min-width: 992px) {
    .offset-lg-0 {
      margin-left: 0;
    }
  }
`;

export const offset_lg_1 = `
  @media (min-width: 992px) {
    .offset-lg-1 {
      margin-left: 8.33333%;
    }
  }
`;

export const offset_lg_2 = `
  @media (min-width: 992px) {
    .offset-lg-2 {
      margin-left: 16.66667%;
    }
  }
`;

export const offset_lg_3 = `
  @media (min-width: 992px) {
    .offset-lg-3 {
      margin-left: 25%;
    }
  }
`;

export const offset_lg_4 = `
  @media (min-width: 992px) {
    .offset-lg-4 {
      margin-left: 33.33333%;
    }
  }
`;

export const offset_lg_5 = `
  @media (min-width: 992px) {
    .offset-lg-5 {
      margin-left: 41.66667%;
    }
  }
`;

export const offset_lg_6 = `
  @media (min-width: 992px) {
    .offset-lg-6 {
      margin-left: 50%;
    }
  }
`;

export const offset_lg_7 = `
  @media (min-width: 992px) {
    .offset-lg-7 {
      margin-left: 58.33333%;
    }
  }
`;

export const offset_lg_8 = `
  @media (min-width: 992px) {
    .offset-lg-8 {
      margin-left: 66.66667%;
    }
  }
`;

export const offset_lg_9 = `
  @media (min-width: 992px) {
    .offset-lg-9 {
      margin-left: 75%;
    }
  }
`;

export const offset_lg_10 = `
  @media (min-width: 992px) {
    .offset-lg-10 {
      margin-left: 83.33333%;
    }
  }
`;

export const offset_lg_11 = `
  @media (min-width: 992px) {
    .offset-lg-11 {
      margin-left: 91.66667%;
    }
  }
`;

export const order_xl_first = `
  @media (min-width: 1320px) {
    .order-xl-first {
      order: -1;
    }
  }
`;

export const order_xl_last = `
  @media (min-width: 1320px) {
    .order-xl-last {
      order: 13;
    }
  }
`;

export const order_xl_0 = `
  @media (min-width: 1320px) {
    .order-xl-0 {
      order: 0;
    }
  }
`;

export const order_xl_1 = `
  @media (min-width: 1320px) {
    .order-xl-1 {
      order: 1;
    }
  }
`;

export const order_xl_2 = `
  @media (min-width: 1320px) {
    .order-xl-2 {
      order: 2;
    }
  }
`;

export const order_xl_3 = `
  @media (min-width: 1320px) {
    .order-xl-3 {
      order: 3;
    }
  }
`;

export const order_xl_4 = `
  @media (min-width: 1320px) {
    .order-xl-4 {
      order: 4;
    }
  }
`;

export const order_xl_5 = `
  @media (min-width: 1320px) {
    .order-xl-5 {
      order: 5;
    }
  }
`;

export const order_xl_6 = `
  @media (min-width: 1320px) {
    .order-xl-6 {
      order: 6;
    }
  }
`;

export const order_xl_7 = `
  @media (min-width: 1320px) {
    .order-xl-7 {
      order: 7;
    }
  }
`;

export const order_xl_8 = `
  @media (min-width: 1320px) {
    .order-xl-8 {
      order: 8;
    }
  }
`;

export const order_xl_9 = `
  @media (min-width: 1320px) {
    .order-xl-9 {
      order: 9;
    }
  }
`;

export const order_xl_10 = `
  @media (min-width: 1320px) {
    .order-xl-10 {
      order: 10;
    }
  }
`;

export const order_xl_11 = `
  @media (min-width: 1320px) {
    .order-xl-11 {
      order: 11;
    }
  }
`;

export const order_xl_12 = `
  @media (min-width: 1320px) {
    .order-xl-12 {
      order: 12;
    }
  }
`;

export const offset_xl_0 = `
  @media (min-width: 1320px) {
    .offset-xl-0 {
      margin-left: 0;
    }
  }
`;

export const offset_xl_1 = `
  @media (min-width: 1320px) {
    .offset-xl-1 {
      margin-left: 8.33333%;
    }
  }
`;

export const offset_xl_2 = `
  @media (min-width: 1320px) {
    .offset-xl-2 {
      margin-left: 16.66667%;
    }
  }
`;

export const offset_xl_3 = `
  @media (min-width: 1320px) {
    .offset-xl-3 {
      margin-left: 25%;
    }
  }
`;

export const offset_xl_4 = `
  @media (min-width: 1320px) {
    .offset-xl-4 {
      margin-left: 33.33333%;
    }
  }
`;

export const offset_xl_5 = `
  @media (min-width: 1320px) {
    .offset-xl-5 {
      margin-left: 41.66667%;
    }
  }
`;

export const offset_xl_6 = `
  @media (min-width: 1320px) {
    .offset-xl-6 {
      margin-left: 50%;
    }
  }
`;

export const offset_xl_7 = `
  @media (min-width: 1320px) {
    .offset-xl-7 {
      margin-left: 58.33333%;
    }
  }
`;

export const offset_xl_8 = `
  @media (min-width: 1320px) {
    .offset-xl-8 {
      margin-left: 66.66667%;
    }
  }
`;

export const offset_xl_9 = `
  @media (min-width: 1320px) {
    .offset-xl-9 {
      margin-left: 75%;
    }
  }
`;

export const offset_xl_10 = `
  @media (min-width: 1320px) {
    .offset-xl-10 {
      margin-left: 83.33333%;
    }
  }
`;

export const offset_xl_11 = `
  @media (min-width: 1320px) {
    .offset-xl-11 {
      margin-left: 91.66667%;
    }
  }
`;

export const em_page_grid = `
.em-page-grid {
    max-width: 1320px;
    padding-left: 0;
    padding-right: 0;
    overflow: hidden;
  }

  @media (min-width: 768px) {
    .em-page-grid {
      padding-left: 24px;
      padding-right: 24px;
    }
  }
`;
